<style lang="less" scoped>
  @import "../vendor/util.less";

  .iframe {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100% !important;
    background-color: #fff;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    overflow-y: scroll;
    z-index: 10;
    overflow-x: hidden;
    webkitOverflowScrolling: touch;

  }

  .loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100% !important;
    z-index: 11;
    background-color: rgba(255, 255, 255, 0.5);
    i {
      position: absolute;
      .center();
      width: 1.5rem;
      height: 1.5rem;
      background: url("../img/loading.gif") no-repeat;
      background-size: 100%;
    }
  }

  iframe {
    -webkit-overflow-scrolling: touch;
    width: 1px;
    min-width: 100%;
    *width: 100%;
  }
  .iosIframe {
    overflow: scroll;
  }
</style>
<template>
  <div class="iframe">
    <navigation v-if="ifShowNavigation"></navigation>
    <div v-show="loading" class="loading">
      <i></i>
    </div>
    <iframe width="100%" height="100%" @load="loading = false" :src="url" :scrolling="ifScrolling" :class="iframeName"></iframe>
  </div>
</template>
<script>
  import getBrowserInfo from 'bjxy-common/helper/getBrowserInfo'
  import navigation from 'bjxy-component/navigation/index.vue'
  import replaceDomain from 'bjxy-common/xyHelper/replaceDomain'

  export default{
    data(){
      return {
        loading: true,
        ifScrolling: 'auto',
        iframeName: '',
        ifShowNavigation: false
      }
    },
    props: ['query'],
    watch:{
      query(newVal,oldVal){
        if (newVal&&newVal.src) {
          this.commit('pageTitle', {pageTitle: decodeURIComponent(this.query.title)})
        }
      }
    },
    computed: {
      url(){
        return replaceDomain(decodeURIComponent(this.query.src), true)
      }
    },
    activated(){
      let ua = window.navigator.userAgent;
      if (getBrowserInfo().ios) {
        let mc = ua.match(/\d+_\d+_*\d*/)
        let osVersion = 0;
        if (mc && mc[0]){
          osVersion = mc[0].replace(/_\d+_*\d*/,'')
        }
        if (Number(osVersion) < 13){
          this.ifScrolling = 'no';
          this.iframeName = 'iosIframe'
        }
      } else if (getBrowserInfo().android) {
        this.ifScrolling = 'auto';
      }
      this.loading = true;
      this.$nextTick( ()=> {
        var ifShowNavigation = (this.$route.meta && this.$route.meta.ifShowNavigation) || (this.query.ifShowNavigation && this.query.ifShowNavigation !== 'false')
        this.ifShowNavigation = ifShowNavigation
        this.commit('pageTitle', {pageTitle: decodeURIComponent(this.query.title)})
      })
    },
    methods: {
      back: function() {
        this.$router.back();
      }
    },
    components: {navigation}
  }
</script>
